import { DisplayText, TextStyle } from '@superops/ui-design-system';
import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { CHAT_TIMER_INSEC } from '@nile/components/src/Pages/SystemTrayChatPage/constants';
import { EventEmitter } from '@nile/components';

let timer;
export default function TimerComponent({
  timerInSec,
  threadData,
  chatStatus,
  onlyTimer,
  closeSession,
  minimise
}) {
  const [time, setTime] = useState(timerInSec);
  const timerRef = useRef(timerInSec);
  timerRef.current = time;

  const closeWindow = () => {
    localStorage.removeItem('chatTimer');
    setTime(CHAT_TIMER_INSEC);
    EventEmitter.dispatch('closeGlobalConversation', 'agentChatWindow');
  };

  const startTimer = () => {
    if (chatStatus?.sessionInitiated && !chatStatus?.sessionConnected) {
      const activeTimer = localStorage.getItem('chatTimer');
      if (activeTimer) {
        setTime(activeTimer - 2);
      }
      if (timer) {
        clearInterval(timer);
      }
      timer = setInterval(() => {
        setTime((prevState) => {
          localStorage.setItem('chatTimer', timerRef.current);
          if (prevState === 0) {
            localStorage.removeItem('chatTimer');
            clearInterval(timer);
            closeSession({ convThread: threadData });
            return 0;
          }
          return prevState - 1;
        });
      }, 1000);
    }
  };

  useEffect(() => {
    if (chatStatus?.sessionClosed) {
      if (timer) {
        clearInterval(timer);
      }
      return;
    }
    startTimer();
  }, [
    chatStatus?.sessionInitiated,
    chatStatus?.sessionClosed,
    chatStatus?.sessionConnected,
    minimise
  ]);

  if (time < 0 || !time) {
    return <></>;
  }

  if (onlyTimer && time) {
    return (
      <DisplayText>
        <TextStyle variation={time < 60 ? 'negative' : null}>
          {`${Math.floor(time / 60)}`.padStart(2, 0)}:{' '}
          {`${time % 60}`.padStart(2, 0)}
        </TextStyle>
      </DisplayText>
    );
  }

  return (
    <>
      {time === 0 ? (
        <div className="flex fcol g3">
          <DisplayText>
            <FormattedMessage id="error.page.config.session.expired.title" />
          </DisplayText>
          <div className="flex-center ptr" onClick={closeWindow}>
            <DisplayText>
              <TextStyle variation="negative">
                <FormattedMessage id="common.close" />
              </TextStyle>
            </DisplayText>
          </div>
        </div>
      ) : (
        <div className="flex g3">
          <DisplayText>
            <TextStyle variation={time < 60 ? 'negative' : null}>
              <FormattedMessage id="msp.chat.session.expiresIn" />
            </TextStyle>
          </DisplayText>
          <DisplayText>
            <TextStyle variation={time < 60 ? 'negative' : null}>
              {`${Math.floor(time / 60)}`.padStart(2, 0)}:{' '}
              {`${time % 60}`.padStart(2, 0)}
            </TextStyle>
          </DisplayText>
        </div>
      )}
    </>
  );
}
